export var MadeShotOptions = [
  "foulOnShot",
  "fastBreak",
  "defensiveGoalTending",
];

export var MissedShotOptions = [];
